export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.user) {
        next('/login')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CheckUser.js